module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "app-sidebar",
    attrs: {
      "id": "app-sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "audi-logo"
  }, [_c('svg', {
    staticClass: "block size-full",
    attrs: {
      "fill": "none",
      "preserveAspectRatio": "none",
      "viewBox": "0 0 130 45"
    }
  }, [_c('g', {
    attrs: {
      "id": "Audi Rings"
    }
  }, [_c('path', {
    attrs: {
      "d": "M107.178 39.964C103.193 39.964 99.5207 38.6105 96.5838 36.3416C99.5642 32.5215 101.348 27.7173 101.348 22.5C101.348 17.2831 99.5642 12.4789 96.5838 8.65845C99.5207 6.39 103.193 5.03595 107.178 5.03595C116.774 5.03595 124.581 12.8704 124.581 22.5C124.581 32.13 116.774 39.964 107.178 39.964ZM68.3315 36.3416C71.3123 32.5215 73.0962 27.7173 73.0962 22.5C73.0962 17.2831 71.3123 12.4789 68.3319 8.65845C71.2683 6.39 74.942 5.03595 78.926 5.03595C82.9104 5.03595 86.5831 6.39 89.52 8.65845C86.5396 12.4789 84.7557 17.2831 84.7557 22.5C84.7557 27.7173 86.5396 32.5215 89.52 36.3416C86.5831 38.6105 82.9104 39.964 78.926 39.964C74.942 39.964 71.2683 38.6105 68.3315 36.3416ZM40.0796 36.3416C43.0604 32.5215 44.8443 27.7173 44.8443 22.5C44.8443 17.2831 43.0604 12.4789 40.08 8.65845C43.0164 6.39 46.6901 5.03595 50.674 5.03595C54.658 5.03595 58.3317 6.39 61.2681 8.65845C58.2877 12.4789 56.5038 17.2831 56.5038 22.5C56.5038 27.7173 58.2877 32.5215 61.2681 36.3416C58.3317 38.6105 54.658 39.964 50.674 39.964C46.6901 39.964 43.0164 38.6105 40.0796 36.3416ZM5.01852 22.5C5.01852 12.8704 12.8259 5.03595 22.4221 5.03595C26.4061 5.03595 30.0798 6.39 33.0162 8.65845C30.0358 12.4789 28.2519 17.2831 28.2519 22.5C28.2519 27.7173 30.0358 32.5215 33.0162 36.3416C30.0798 38.6105 26.4061 39.964 22.4221 39.964C12.8259 39.964 5.01852 32.13 5.01852 22.5ZM36.5481 32.6821C34.4884 29.8134 33.2704 26.298 33.2704 22.5C33.2704 18.7024 34.4884 15.1866 36.5481 12.3178C38.6078 15.1866 39.8258 18.7024 39.8258 22.5C39.8258 26.298 38.6078 29.8134 36.5481 32.6821ZM64.8 32.6821C62.7403 29.8134 61.5223 26.298 61.5223 22.5C61.5223 18.7024 62.7403 15.1866 64.8 12.3178C66.8597 15.1866 68.0777 18.7024 68.0777 22.5C68.0777 26.298 66.8597 29.8134 64.8 32.6821ZM93.0519 32.6821C90.9922 29.8134 89.7742 26.298 89.7742 22.5C89.7742 18.7024 90.9922 15.1866 93.0519 12.3178C95.1116 15.1866 96.3296 18.7024 96.3296 22.5C96.3296 26.298 95.1116 29.8134 93.0519 32.6821ZM107.178 0C101.827 0 96.9103 1.89315 93.0519 5.04315C89.1935 1.89315 84.2768 0 78.926 0C73.5751 0 68.6584 1.89315 64.8 5.04315C60.9416 1.89315 56.0244 0 50.674 0C45.3232 0 40.4065 1.89315 36.5481 5.04315C32.6897 1.89315 27.7725 0 22.4221 0C10.0586 0 0 10.0935 0 22.5C0 34.9069 10.0586 45 22.4221 45C27.7725 45 32.6897 43.1073 36.5481 39.9568C40.4065 43.1073 45.3232 45 50.674 45C56.0244 45 60.9416 43.1073 64.8 39.9568C68.6584 43.1073 73.5751 45 78.926 45C84.2768 45 89.1935 43.1073 93.0519 39.9568C96.9103 43.1073 101.827 45 107.178 45C119.541 45 129.6 34.9069 129.6 22.5C129.6 10.0935 119.541 0 107.178 0Z",
      "fill": "white"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "nav-title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "nav flex-column nav-items"
  }, [_c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/marketreports')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/marketreports', 'Überblick')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Überblick")])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/wizard')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/wizard', 'Wizard')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("auto_fix_high")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v("Wizard")])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll') && !_vm.globals.currentUserInfo.IsAudiUser) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/clientmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/clientmanagement', _vm.lang.A0000)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("contacts_product")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0000))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/locationmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/locationmanagement', _vm.lang.A0001)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("location_on")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0001))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/usermanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/usermanagement', _vm.lang.A0010)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("group")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0010))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/projectmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/projectmanagement', _vm.lang.A0011)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("folder_open")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0011))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') && !_vm.globals.isLocalAgencyUser) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/agencymanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/agencymanagement', _vm.lang.A0012)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("business")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0012))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/surveymanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/surveymanagement', _vm.lang.A0013)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("quiz")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0013))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && _vm.globals.currentUserRole < 3) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/checkmanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/checkmanagement', _vm.lang.A0014)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("checklist")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0014))])]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/kpimanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/kpimanagement', _vm.lang.A0016)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("analytics")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0016))])]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shoppermanagement') &&
    _vm.globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
    !(
      _vm.feature.isAudiTarget &&
      (_vm.globals.isLeadAgencyUser || _vm.globals.isAudiUser)
    )
  ) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/shoppermanagement')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/shoppermanagement', _vm.lang.A0023)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("person_check")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0023))])]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('recruiting') &&
    _vm.globals.isAccessAllowed('LoopOp_Recruiting_ReadAll')
  ) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/recruiting')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/recruiting', _vm.lang.A0029)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("person_search")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0029))])]) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('shopperApproval') && _vm.globals.currentUserInfo) ? _c('div', {
    staticClass: "nav-item",
    class: {
      active: _vm.isActiveRoute('/shopperapproval')
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/shopperapproval', _vm.lang.A0032)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("task_alt")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.A0032))])]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650aa386","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSidebar.vue
// module id = 1687
// module chunks = 1